<script setup lang="ts">
import DownArrow from "../../regularComponents/UIComponents/SVG/chevrons/DownArrow.vue";

import { SecondaryDataInterface } from "@/types/ContentType";

import { computed } from "vue";
import Grid from "@/components/regularComponents/layoutComponents/Grid.vue";
import { useMainStore } from "@/store/main/index";
import { ref, Ref } from "vue";

/**
 * @author Alexander Kenchoshvili
 */

//
const mainStore = useMainStore();
const rootEl: Ref<HTMLElement | undefined> = ref();

const props = defineProps<{
  contentData: SecondaryDataInterface | undefined;
}>();

const downloadLink = computed(() => props?.contentData?.data?.list?.[0]?.file?.[0]?.url);
</script>

<template>
  <div v-if="!contentData?.conf?.conf?.includes('hide-component')" class="download-file d-flex j-center">
    <Grid
      :gridType="3"
      :style="{
        height: mainStore.windowWidth >= 984 ? `${rootEl?.scrollHeight}px` : '100%',
      }"
    />
    <a
      :href="downloadLink"
      target="_blank"
      class="download-file__wrapper d-flex j-btw al-center pos-rel"
    >
      <div class="download-file__arrow-wrapper ov-hidden">
        <div class="download-file__arrow">
          <DownArrow />
        </div>
        <div class="download-file__arrow">
          <DownArrow />
        </div>
      </div>
      <h2 class="download-file__title uppercase hl-2-light">
        {{ $t("download presentation pdf design") }}
      </h2>
    </a>
  </div>
</template>

<style lang="scss">
@keyframes slide {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0%);
  }
}
.download-file {
  margin-top: 209px;
  padding: 161px 0;
  background-color: $lotion;
  position: relative;
  @include maxq(desktop-2k) {
    margin-top: 139px;
    padding: 107px 0;
  }
  @include maxq(desktop-lg) {
    margin-top: 104px;
    padding: 80px 0;
  }
  @include maxq(tablet) {
    margin-top: 80px;
    padding: 80px 0;
  }
  @include maxq(mobile) {
    margin-top: 72px;
    padding: 80px 52px;
  }
  @include maxq(mobile-sm) {
    padding: 80px 20px;
  }

  .page-grid {
    z-index: 1;
    padding-left: 0;
    &--3 div {
      border-right: 1px solid $brightGray;
      @include maxq(mobile) {
        border-right: unset;
        &:nth-child(2) {
          border-right: 1px solid $brightGray;
        }
      }
    }
  }

  &__wrapper {
    box-shadow: 0 0 0 1px $brightGray;
    padding: 80px 96px;
    background-color: $lotion;
    z-index: 1;

    @include maxq(desktop-2k) {
      padding: 53px 64px;
    }
    @include maxq(desktop-lg) {
      padding: 40px 48px;
    }
    @include maxq(tablet) {
      padding: 40px 55px;
    }
    @include maxq(mobile) {
      padding: 40px;
    }
    @include maxq(mobile-sm) {
      padding: 20px;
    }
    transition: box-shadow 0.3s ease-in-out;
    @include hover {
      box-shadow: 0 0 0 2px $black;
    }
    @include hover {
      .download-file__arrow {
        animation: 900ms slide cubic-bezier(0.33, 1, 0.68, 1);
      }
    }
  }
  &__arrow-wrapper {
    border: 1px solid #e1e1e1;
    width: 206px;
    height: 206px;

    @include maxq(desktop-2k) {
      width: 137px;
      height: 137px;
    }
    @include maxq(desktop-lg) {
      width: 104px;
      height: 104px;
    }
    @include maxq(mobile) {
      flex: 0 0 104px;
    }
    @include maxq(mobile-sm) {
      width: 70px;
      height: 70px;
      flex: 0 0 70px;
    }
  }
  &__arrow {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      @include maxq(desktop-2k) {
        display: block;
        width: 42px;
        height: 51px;
      }
      @include maxq(desktop-lg) {
        width: 31px;
        height: 38px;
      }
    }
  }

  &__title {
    margin-left: 41px;
    font-size: 72px;
    white-space: nowrap;
    @include maxq(desktop-2k) {
      font-size: 48px;
      margin-left: 27px;
    }
    @include maxq(desktop-lg) {
      font-size: 32px;
      margin-left: 16px;
      line-height: 52px;
    }

    @include maxq(mobile) {
      white-space: unset;
      font-size: 20px;
      line-height: 28px;
    }
    @include maxq(mobile-sm) {
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
